export default function dynamicInputFormat($parse) {
  'ngInject';

  return {
    require: 'ngModel',
    link($scope, $element, $attrs, $ngModel) {
      const formatExpression = $scope.$eval($attrs.dynamicInputFormat);
      if (formatExpression) {
        const parsed = $parse(formatExpression);
        $ngModel.$formatters.push((value) => parsed($scope, { value }));
      }
    },
  };
}
